export default Object.freeze({
    en: {
        package_options: [
            {
                title: 'Basic',
                key: 'basic',
                monthlyPrice: `${env('VUE_APP_PACKAGE_REGULAR')}`,
                yearlyPrice: `${env('VUE_APP_PACKAGE_REGULAR_YEARLY')}`,
                benefits: [
                    'First month free',
                    'Unlimited services',
                    'Unlimited reservations',
                    'Unlimited employees',
                    'Unlimited locations',
                    'Inactivity settings',
                    'Profile configuration',
                    'Клиентская база и возможность блокировки пользователей',
                    'Client base and the ability to block users',
                ],
                class: 'basic',
            },
            {
                title: 'Professional',
                key: 'professional',
                monthlyPrice: `${env('VUE_APP_PACKAGE_SUBDOMAIN')}`,
                yearlyPrice: `${env('VUE_APP_PACKAGE_SUBDOMAIN_YEARLY')}`,
                benefits: [
                    'First month free',
                    'Unlimited services',
                    'Unlimited reservations',
                    'Unlimited employees',
                    'Unlimited locations',
                    'Inactivity settings',
                    'Profile configuration',
                    'Separate reservation website exclusively for your company',
                    'Configuration of your website (theme selection, images, description)',
                    'Subdomain with your website',
                    'Sticker with QR code',
                    'Client base and the ability to block users',
                    'Telegram notifications',
                ],
                class: 'professional',
            },
        ],
    },
    sr: {
        package_options: [
            {
                title: 'Osnovni',
                key: 'basic',
                monthlyPrice: `${env('VUE_APP_PACKAGE_REGULAR')}`,
                yearlyPrice: `${env('VUE_APP_PACKAGE_REGULAR_YEARLY')}`,
                benefits: [
                    'Prvi mesec besplatan',
                    'Neograničen broj usluga',
                    'Neograničen broj rezervacija',
                    'Neograničen broj radnika',
                    'Neograničen broj lokacija',
                    'Podešavanja neaktivnosti',
                    'Konfiguracija profila',
                    'Baza klijenata i mogućnost blokiranja korisnika',
                ],
                class: 'basic',
            },
            {
                title: 'Profesionalni',
                key: 'professional',
                monthlyPrice: `${env('VUE_APP_PACKAGE_SUBDOMAIN')}`,
                yearlyPrice: `${env('VUE_APP_PACKAGE_SUBDOMAIN_YEARLY')}`,
                benefits: [
                    'Prvi mesec besplatan',
                    'Neograničen broj usluga',
                    'Neograničen broj rezervacija',
                    'Neograničen broj radnika',
                    'Neograničen broj lokacija',
                    'Podešavanja neaktivnosti',
                    'Konfiguracija profila',
                    'Zaseban sajt za rezervacije za samo vašu kompaniju',
                    'Konfiguracija vašeg sajta (odabir tema, slika, opisa)',
                    'Subdomain sa vašim sajtom',
                    'Nalepnica sa QR kodom',
                    'Baza klijenata i mogućnost blokiranja korisnika',
                    'Telegram notifikacije',
                ],
                class: 'professional',
            },
        ],
    },
    ru: {
        package_options: [
            {
                title: 'Основные',
                key: 'basic',
                monthlyPrice: `${env('VUE_APP_PACKAGE_REGULAR')}`,
                yearlyPrice: `${env('VUE_APP_PACKAGE_REGULAR_YEARLY')}`,
                benefits: [
                    'Первый месяц бесплатно',
                    'Неограниченное количество услуг',
                    'Неограниченное количество бронирований',
                    'Неограниченное количество сотрудников',
                    'Неограниченное количество местоположений',
                    'Настройки неактивности',
                    'Конфигурация профиля',
                    'Клиентская база и возможность блокировки пользователей',
                ],
                class: 'basic',
            },
            {
                title: 'Профессиональный',
                key: 'professional',
                monthlyPrice: `${env('VUE_APP_PACKAGE_SUBDOMAIN')}`,
                yearlyPrice: `${env('VUE_APP_PACKAGE_SUBDOMAIN_YEARLY')}`,
                benefits: [
                    'Первый месяц бесплатно',
                    'Неограниченное количество услуг',
                    'Неограниченное количество бронирований',
                    'Неограниченное количество сотрудников',
                    'Неограниченное количество местоположений',
                    'Настройки неактивности',
                    'Конфигурация профиля',
                    'Отдельный сайт для бронирований только для вашей компании',
                    'Настройка вашего сайта (выбор темы, изображений, описания)',
                    'Поддомен для вашего сайта',
                    'Стикер с QR кодом',
                    'Клиентская база и возможность блокировки пользователей',
                    'Уведомления в Telegram',
                ],
                class: 'professional',
            },
        ],
    },
    bih: {
        package_options: [
            {
                title: 'Osnovni',
                key: 'basic',
                monthlyPrice: `${env('VUE_APP_PACKAGE_REGULAR')}`,
                yearlyPrice: `${env('VUE_APP_PACKAGE_REGULAR_YEARLY')}`,
                benefits: [
                    'Prvi mjesec besplatan',
                    'Neograničen broj usluga',
                    'Neograničen broj rezervacija',
                    'Neograničen broj radnika',
                    'Neograničen broj lokacija',
                    'Podešavanja neaktivnosti',
                    'Konfiguracija profila',
                    'Baza klijenata i mogućnost blokiranja korisnika',
                ],
                class: 'basic',
            },
            {
                title: 'Profesionalni',
                key: 'professional',
                monthlyPrice: `${env('VUE_APP_PACKAGE_SUBDOMAIN')}`,
                yearlyPrice: `${env('VUE_APP_PACKAGE_SUBDOMAIN_YEARLY')}`,
                benefits: [
                    'Prvi mjesec besplatan',
                    'Neograničen broj usluga',
                    'Neograničen broj rezervacija',
                    'Neograničen broj radnika',
                    'Neograničen broj lokacija',
                    'Podešavanja neaktivnosti',
                    'Konfiguracija profila',
                    'Zaseban sajt za rezervacije za samo vašu kompaniju',
                    'Konfiguracija vašeg sajta (odabir tema, slika, opisa)',
                    'Subdomain sa vašim sajtom',
                    'Naljepnica sa QR kodom',
                    'Baza klijenata i mogućnost blokiranja korisnika',
                    'Telegram notifikacije',
                ],
                class: 'professional',
            },
        ],
    },
})
